import { render } from "./activityCreate.vue?vue&type=template&id=6a2022e5&scoped=true"
import script from "./activityCreate.vue?vue&type=script&lang=js"
export * from "./activityCreate.vue?vue&type=script&lang=js"

import "./activityCreate.vue?vue&type=style&index=0&id=6a2022e5&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2022e5"]])

export default __exports__